module.exports = __webpack_public_path__ + "img/lowest.acd0bfa6.svg";